import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Transition as _Transition, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col overflow-hidden flex-grow gap-2 max-h-screen" }
const _hoisted_2 = { class: "flex flex-grow overflow-hidden gap-2" }
const _hoisted_3 = { class: "flex flex-col gap-2" }
const _hoisted_4 = { class: "flex flex-col overflow-auto gap-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "flex gap-2 font-bold items-center"
}
const _hoisted_7 = { class: "flex-shrink-0 h-[140px] overflow-auto" }
const _hoisted_8 = {
  key: 0,
  class: "p-1 h-8"
}
const _hoisted_9 = {
  key: 1,
  class: "overflow-hidden whitespace-nowrap text-ellipsis"
}

import {onMounted, ref} from 'vue';
import router from "@/router";
import {mutation, query} from "@/graphql";
import Spinner from "@/components/Base/Spinner.vue";
import ProductFormular from "@/components/ProductFormular/ProductFormular.vue";
import SignalBus from "@/application/SignalBus";
import storage from "@/application/storage";
import TRToolbar from "@/components/Base/v2/TRToolbar.vue";
import TRButton from "@/components/Base/v2/TRButton.vue";
import TRContainer from "@/components/Base/v2/TRContainer.vue";
import TRTable from "@/components/Base/TRTable.vue";
import {electron} from "@/electron";
import TRInput from "@/components/Base/v2/TRInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Article',
  setup(__props) {

const articleNumber = ref();
const articleNumbers = ref([]);
const fields = ref([])
const showEmptyInput = ref(false);
const pictureInformation = ref({});
const pictures = ref([]);
const logos = ref([]);
const selectedPicture = ref();
const idMagazine = ref(0);
const idMarket = ref(0);
const loading = ref(false);
const oldDataPicture = ref([]);
const oldDataLogo = ref([]);
const oldDataFields = ref([]);
const productJoinProductPictureId = ref(0);
const productJoinProductLogoId = ref(0);
const searchArticleIndex = ref(0);
const formularNames = ref([]);
const ready = ref(0);
const purchasers = ref([]);
const purchaserId = ref(116);
const exists = ref(false);
const draggableFalse = ref(false);
const pictureResult = ref([]);
const logoResult = ref([]);
let selectedIndex = ref(0);

const magazineProductHeader = [
  {title: 'Produktname', field: 'produktName'},
  {title: 'Seite', field: 'pagePosition', width: 50},
  {title: 'Werbemittel', field: 'magazineName'},
  {title: 'Markt', field: 'marketName'},
  {title: 'Aktionen', field: 'seTool', width: 200}
];

const magazineSelectionChange = (selectedRows) => {

  if (selectedRows.length > 0) {
    const selectedId = selectedRows[0]?.id || 0;
    selectedIndex.value = artikelInformation.value.findIndex((item) => item.id === selectedId);
    idMagazine.value = artikelInformation.value[selectedIndex.value].magazineId;
    idMarket.value = artikelInformation.value[selectedIndex.value].marketId;
    loadData();
  }
}

let lastProductChanges = {};

const page = ref({
  pagePosition: 0,
  magazineId: 0,
  pageId: 0,
  projectId: 0,
});
const product = ref({
  productId: 0,
  articleNumber: articleNumber.value,
  productTemplateId: 0,
  productTemplateName: '',
  placeholderId: 0,
  productCustomFields: fields.value,
  productPictures: pictures.value,
  productLogos: logos.value,
})

const artikelInformation = ref([]);

async function getFormularNames() {
  const [data, err] = await query.getFormularNames();
  formularNames.value = data;
  if (err) {
    console.error(err);
  }
}

function changeDraggable() {
  draggableFalse.value = !draggableFalse.value;
}

async function newImageAdded(image, type) {
  // getImageByPath
  
  if (type == 'picture') {
    product.value.productPictures.push(image);
    //ready.value = Math.random();
  } else {
    product.value.productLogos.push(image);
    //ready.value = Math.random();
  }
}

function onClickGetImageData(image) {
  pictureInformation.value = image;
}

async function createArtikelNumber() {
  try {

    await mutation.createArtikelNumber(articleNumber.value, purchaserId.value);
    await loadData();
  } catch (e) {
    console.error(e);
  }
}

const openInPhotoshop = () => {
  let picture = pictureInformation.value.originalFilePath;
  electron.openFileInPhotoshop(picture);
};

const openAndHighlightFileInFinder = () => {
  let picture = pictureInformation.value.originalFilePath;
  electron.openFileInFinder(picture);
};

async function loadData() {
  if (!articleNumber.value) {
    return;
  }
  const [data, err] = await query.getArticleInformation(articleNumber.value, idMagazine.value, idMarket.value);
  if (err) {
    console.error(err);
  }
  if (!showEmptyInput.value) {
    fields.value = data?.fields.filter((field: any) => field.fieldValue !== "");
  } else {
    fields.value = data?.fields;
  }
  pictures.value = data?.picture;
  logos.value = data?.logo;

  exists.value = data?.exists;
  if (data?.exists) {
    product.value.productCustomFields = data?.fields;
    product.value.productPictures = data?.picture;
    product.value.productLogos = data?.logo;
    product.value.productId = data?.productId;
    product.value.productTemplateId = data?.templateId;
    page.value.pageId = data?.pageId;
    page.value.magazineId = idMagazine.value;
    purchaserId.value = data?.purchaserId;

    oldDataPicture.value = data?.picture;
    oldDataLogo.value = data?.logo;
    oldDataFields.value = data?.fields;
  }
  //random id
  ready.value = Math.random();
}

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  if (err) {
    console.error(err);
  }

}

function loadArticleNumber(newArticleNumber) {
  articleNumber.value = newArticleNumber;  // Update the value of the ref
  searchForArticleNumber();
  loadData();
}

async function goToSeTool(projectId, magazineId, pagePosition, marketId) {

  /// query.getAccordionIndex
  const [data, err] = await query.getAccordionIndex(magazineId, pagePosition, marketId, articleNumber.value);
  if (err) {
    console.error(err);
  }
  await router.push('/project/' + projectId + '/' + magazineId + '/' + pagePosition + '/' + marketId + '/' + data);
}

function removePicture() {
  pictures.value.forEach((picture) => {
    if (picture.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      picture.delete = true;
    }
  })
  logos.value.forEach((logo) => {
    if (logo.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      logo.delete = true;
    }
  })
}


function changeArticleNumber() {
  // trim " " from articleNumber
  articleNumber.value = articleNumber.value.trim();
  if (articleNumber.value === '') {
    return;
  }
  if (!articleNumbers.value.includes(articleNumber.value)) {
    articleNumbers.value.push(articleNumber.value);
  }
  searchForArticleNumber();
  loadData();
}

async function searchForArticleNumber() {

  if (articleNumber.value === '') {
    return;
  }
  let [data, err] = await query.searchWhereArticleNumberIs(articleNumber.value);
  try {
    artikelInformation.value = data;
  } catch (e) {
    console.error(e);
  }
}

function toggleEmptyInput() {
  showEmptyInput.value = !showEmptyInput.value;
  loadData();
}

function toggle(value) {
  if (value === 'Aktiv') {
    pictureInformation.value.isActive = !pictureInformation.value.isActive

  } else {
    pictureInformation.value.isDefault = !pictureInformation.value.isDefault
  }
  pictures.value.forEach((picture) => {
    if (picture.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      picture.isActive = pictureInformation.value.isActive;
      picture.isDefault = pictureInformation.value.isDefault;
    } else {
      picture.isDefault = false;
    }
  })
  logos.value.forEach((logo) => {
    if (logo.productJoinProductPictureId === pictureInformation.value.productJoinProductPictureId) {
      logo.isActive = pictureInformation.value.isActive;
      logo.isDefault = pictureInformation.value.isDefault;
    } else {
      logo.isDefault = false;
    }
  })
}

function getImageInformation(value) {
  pictureInformation.value = value;
  if (value.productJoinProductPictureId) {
    productJoinProductPictureId.value = value.productJoinProductPictureId;
  }
  if (value.productJoinProductLogoId) {
    productJoinProductLogoId.value = value.productJoinProductLogoId;
  }
}

function onDragUpdate(event, type) {
  if (type === 'picture') {
    this.pictures.forEach((picture, index) => {
      picture.position = index + 1;
    });
  } else {
    this.logos.forEach((logo, index) => {
      logo.position = index + 1;
    });
  }

}


//vue composition api on created


onMounted(async () => {
  const artNo = router.currentRoute.value.params.articleNumber;

  articleNumber.value = await storage.get("articleNumber");


  const splitArticleNumbers = artNo.split(/[\s,]+/).filter(item => item.trim() !== '' && item.trim() !== null);
  if (splitArticleNumbers.length > 0) {
    articleNumbers.value = splitArticleNumbers;
    articleNumber.value = splitArticleNumbers[0];
  }


  await loadData();
  await getFormularNames();
  await searchForArticleNumber();
  await getPurchasers();

});

function resetChanges() {
  pictures.value = oldDataPicture.value;
  logos.value = oldDataLogo.value;
  fields.value = oldDataFields.value;
}

function onProductChanges(data) {

  
  lastProductChanges = data
}

function resetHighlights() {
}

async function saveArticleNumber(bool) {
  try {
    loading.value = true;

    let pictureChanges = [];
    let logoChanges = [];
    let fieldChanges = [];


    for (const [_, v] of Object.entries(lastProductChanges)) {
      if (v.type === 'field') {


        fieldChanges.push({
          value: v.value,
          field: v.key,
          productCustomFieldId: 0,
          productId: product.value.productId
        })

      }
      if (v.type === 'picture') {
        // Durchlaufe das Array innerhalb von v.value
        v.value.forEach(picture => {
          pictureChanges.push({
            productJoinProductPictureId: picture.productJoinProductPictureId,
            productPictureId: picture.productPictureId,
            teamId: picture.teamId,
            isActive: picture.isActive,
            previewSmall: picture.previewSmall,
            previewMedium: picture.previewMedium,
            previewLarge: picture.previewLarge,
            position: picture.position,
            markedForDeletion: picture.markedForDeletion,
            isDefault: picture.isDefault,
            name: picture.name,
            dateTimeCreated: picture.dateTimeCreated,
            dateTimeUpdated: picture.dateTimeUpdated,
            delete: picture.delete,
            added: picture.add || false,
            originalFilePath: picture.originalFilePath,
            isRemoved: picture.isRemoved || false
          });
        });
      }
      if (v.type === 'logo') {
        v.value.forEach(logo => {
          logoChanges.push({
            productJoinProductLogoId: logo.productJoinProductLogoId,
            productLogoId: logo.productLogoId,
            teamId: logo.teamId,
            isActive: logo.isActive,
            previewSmall: logo.previewSmall,
            previewMedium: logo.previewMedium,
            previewLarge: logo.previewLarge,
            position: logo.position,
            markedForDeletion: logo.markedForDeletion,
            name: logo.name,
            dateTimeCreated: logo.dateTimeCreated,
            dateTimeUpdated: logo.dateTimeUpdated,
            delete: logo.delete,
            added: logo.add || false,
            originalFilePath: logo.originalFilePath,
            isRemoved: logo.isRemoved || false
          });
        });
      }
    }

    const data = {
      saveInBaseArticle: bool,
      purchaserId: purchaserId.value,
      articleNumber: articleNumber.value,
      magazineId: idMagazine.value || 0,
      marketId: idMarket.value || 0,
      fields: fieldChanges || [],
      picture: pictureChanges || [],
      logo: logoChanges || []
    }
    await mutation.saveArticleNumber(data);
    SignalBus.emit('resetHighlights');

  } catch (e) {
    console.error(e);
  } finally {
    await loadData()
    await searchForArticleNumber();
    loading.value = false;

  }
}

function removeDuplicatesByOriginalFilePath(array) {
  const seen = new Set();
  return array.filter(item => {
    if (seen.has(item.originalFilePath)) {
      return false; // Ignoriere das Element, wenn es bereits gesehen wurde
    }
    seen.add(item.originalFilePath);
    return true; // Behalte das Element, wenn es noch nicht gesehen wurde
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TRToolbar, { class: "flex-shrink-0 h-[35px]" }, {
      default: _withCtx(() => [
        _createVNode(TRButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (saveArticleNumber(false))),
          class: "p-1",
          text: "Speichern",
          "icon-position": 'left',
          icon: "fa-regular fa-floppy-disk"
        }),
        _createVNode(TRButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (saveArticleNumber(true))),
          class: "",
          text: "Speichern im Artikelstamm",
          "icon-position": 'left',
          icon: "fa-solid fa-layer-group"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TRContainer, {
        title: "Artikelsuche",
        class: "w-[100px] flex-shrink-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TRInput, {
              modelValue: articleNumber.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((articleNumber).value = $event)),
              "on-enter": changeArticleNumber,
              "focus-after-clear": true,
              class: "bg-trader-dark-gray p-1",
              type: "gray",
              placeholder: "Artikelnummer..."
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              (articleNumbers.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(articleNumbers.value, (artn) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (artn != null && artn !== 'undefined')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["min-h-[25px] p-1 px-2 cursor-pointer hover:bg-trader-blue", artn === articleNumber.value ? 'bg-trader-blue' : 'bg-trader-light-gray']),
                            onClick: ($event: any) => (loadArticleNumber(artn))
                          }, _toDisplayString(artn), 11, _hoisted_5))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(TRContainer, {
        title: "Artikelinformationen",
        class: "flex-grow",
        scrollable: true
      }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
            : _createCommentVNode("", true),
          (!loading.value && !exists.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[6] || (_cache[6] = [
                _createElementVNode("span", { class: "text-trader-red" }, " Dieser Artikel existiert noch nicht!", -1)
              ])))
            : _createCommentVNode("", true),
          _createVNode(_Transition, {
            "enter-active-class": "transition-opacity duration-500",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity duration-500",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              (!loading.value && exists.value)
                ? (_openBlock(), _createBlock(ProductFormular, {
                    "use-index-d-b": false,
                    page: page.value,
                    "form-id": 1,
                    product: product.value,
                    "show-article-number-input": false,
                    purchaserId: purchaserId.value,
                    key: ready.value,
                    "form-names": formularNames.value,
                    "on-change": onProductChanges,
                    active: true,
                    "on-click-get-image-data": onClickGetImageData,
                    "show-draggable-button": true,
                    "new-image-added": newImageAdded,
                    showPurchaser: true,
                    "draggable-false": draggableFalse.value,
                    "on-click-change-draggable": changeDraggable
                  }, null, 8, ["page", "product", "purchaserId", "form-names", "draggable-false"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(TRContainer, {
        title: "Bildinformationen",
        class: "w-[200px] flex-shrink-0"
      }, {
        default: _withCtx(() => [
          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Bildname", -1)),
          _withDirectives(_createElementVNode("textarea", {
            readonly: true,
            class: "border-2 border-trader-input p-1 shadow-inner-2 w-full",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((pictureInformation.value.name) = $event)),
            rows: "2"
          }, null, 512), [
            [_vModelText, pictureInformation.value.name]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "block mt-2" }, "Bildpfad", -1)),
          _withDirectives(_createElementVNode("textarea", {
            readonly: true,
            class: "border-2 border-trader-input p-1 shadow-inner-2 w-full",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((pictureInformation.value.previewSmall) = $event)),
            rows: "3"
          }, null, 512), [
            [_vModelText, pictureInformation.value.previewSmall]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "block mt-2" }, "Änderungsdatum", -1)),
          _withDirectives(_createElementVNode("textarea", {
            readonly: true,
            class: "border-2 border-trader-input p-1 shadow-inner-2 w-full",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((pictureInformation.value.dateTimeUpdated) = $event)),
            rows: "1"
          }, null, 512), [
            [_vModelText, pictureInformation.value.dateTimeUpdated]
          ]),
          _createElementVNode("div", { class: "flex flex-col gap-1 pt-2" }, [
            _createElementVNode("button", {
              class: "hover:bg-white border border-trader-light-gray p-1 shadow-inner-2 w-full",
              onClick: openAndHighlightFileInFinder
            }, " Bild im Finder anzeigen "),
            _createElementVNode("button", {
              class: "hover:bg-white border border-trader-light-gray p-1 shadow-inner-2 w-full",
              onClick: openInPhotoshop
            }, " Bild in Photoshop öffnen ")
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createBlock(TRTable, {
        class: "flex-grow",
        header: magazineProductHeader,
        "selected-index": _unref(selectedIndex),
        "data-rows": artikelInformation.value,
        singleSelection: true,
        key: artikelInformation.value,
        "on-selection-change": magazineSelectionChange
      }, {
        cell: _withCtx(({ row, field, selected }) => [
          (field === 'seTool')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (row.magazineId)
                  ? (_openBlock(), _createBlock(TRButton, {
                      key: 0,
                      class: "hover:bg-trader-blue px-2 h-full min-w-[200px] rounded",
                      icon: "fa-solid fa-share",
                      "icon-position": "left",
                      onClick: ($event: any) => (goToSeTool(row.projektId, row.magazineId, row.pagePosition, row.marketId))
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" Im Werbemittel anzeigen ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(row[field]), 1))
        ]),
        _: 1
      }, 8, ["selected-index", "data-rows"]))
    ])
  ]))
}
}

})